const Newsletters = (function(window, $) {

    function Newsletter()
    {
        this.$newsletterOverview = $('.page-newsletters');

        if (this.$newsletterOverview.length > 0) {
            this.toggleCheckboxes();
        }
    }

    function openCheckboxes(checkboxContainer)
    {
        let checkboxButton = checkboxContainer.parent().find('.collapse-checkboxes');

        checkboxContainer.removeClass('collapsed');
        checkboxButton.removeClass('closed');
        checkboxButton.addClass('open');
    }

    function checkCheckboxes(checkboxContainer, checked)
    {
        checkboxContainer.find('input').prop('checked', checked).trigger('change');
    }

    function openToaster(newsletterCount)
    {
        let toaster = $('.subscribe-toaster');

        if(!toaster.hasClass('active')) {
            toaster.addClass('active');
        }

        let newsletterWord = (newsletterCount == 0 || newsletterCount > 1) ? 'nieuwsbrieven' : 'nieuwsbrief';
        let selectedSentence = 'Je hebt  <i>' + newsletterCount + '</i> '+ newsletterWord +' geselecteerd';

        toaster.find('.newsletter-selected-text').html(selectedSentence);
    }

    function closeToaster()
    {
        $('.subscribe-toaster').removeClass('active');
    }

    function hasId()
    {
        // (new URL(location.href)).searchParams.get('id') 
        return $('input:hidden[name="user_id"]').val();
    }


    /**
     * Toggle Checkboxes
     */
    Newsletter.prototype.toggleCheckboxes = function ()
    {
        let checkboxes = $('.newsletter-checkbox input');
        let checkedCheckboxes = $('.newsletter-checkbox input:checked');

        /**
         * Open checkboxes if checked
         */
        openCheckboxes(checkedCheckboxes.closest('.newsletter-checkbox'));

        /**
         * Open checkboxes with button
         */
        $('.collapse-checkboxes').on('click', function() {
            let checkboxContainer = $(this).closest('.newsletter-info').next('.newsletter-checkbox');
            let onlyOpen = $(this).hasClass('only-open');

            if(checkboxContainer.find('input:checked').length < 1) {
                if(onlyOpen) {
                    openCheckboxes(checkboxContainer);
                } else {
                    checkCheckboxes(checkboxContainer, true)
                }
            } else {
                checkCheckboxes(checkboxContainer, false)
            }
        });

        checkboxes.on('change', function() {
            let checkboxContainer = $(this).closest('.newsletter-checkbox');
            let checkboxButton = checkboxContainer.parent().find('.collapse-checkboxes');
            let mainCheckbox = checkboxContainer.find('input.main-newsletter');

            //Toggle main checkbox
            if(checkboxContainer.find('input.sub-newsletter').length > 0) {
                if (checkboxContainer.find('input.sub-newsletter:checked').length < 1) {
                    mainCheckbox.prop('checked', false);
                } else {
                    mainCheckbox.prop('checked', true);
                }
            }

            //Toggle checkbox container
            if(checkboxContainer.find('input:checked').length < 1) {
                //No childs selected, uncheck main
                checkboxButton.removeClass('checked');
                checkboxButton.addClass('unchecked');
            } else {
                //If one or more subs checked, show checkboxes
                openCheckboxes(checkboxContainer);
                checkboxButton.removeClass('unchecked');
                checkboxButton.addClass('checked');
            }

            // if any checkboxes is selected or id known
            if($('.newsletter-checkbox input:checked').length < 1 && !hasId()) {
                closeToaster();
            } else {
                let mainCheckboxes = $('.newsletter-checkbox:not(.count-sub-items) input.main-newsletter:checked').length;
                let subCheckboxes = $('.newsletter-checkbox.count-sub-items input.sub-newsletter:checked').length;
                openToaster(mainCheckboxes + subCheckboxes);
            }
        });

        checkboxes.trigger('change');

    };

    return Newsletter;
}(window, jQuery));

export { Newsletters };
